import styled from "styled-components";

const AccordionHeader = styled.div`
  display: grid;
  grid-template-columns: 1fr 0.5fr 0.5fr;
  width: 100%;
  padding: 24px 0 0 40px;
  align-items: center;
  gap: 10px;
  h3 {
    font-size: 18px;
    font-family: "latobold";
  }
  button {
    border-radius: 4px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
    border: solid 1px #dcdcdc;
    background-color: #fff;
    font-size: 12px;
    height: 36px;
    text-transform: capitalize;
    padding: 0 15px;
    svg {
      margin-right: 9px;
    }
  }
  @media (max-width: 690px) {
    display: flex;
    flex-direction: column;
    padding: 20px 0 0 20px;
    align-items: flex-start;
    h3 {
      font-size: 16px;
    }
  }
`;
const CreateGroupWrappe = styled.div`
  .image-container {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    h3 {
      font-size: 16px;
      color: #606060;
      font-family: "latobold";
      padding: 15px;
    }
    .image-wrapper {
      width: 90px;
      height: 90px;
      border-radius: 50%;
      overflow: hidden;
      position: relative;
      .image-upload-icon {
        position: absolute;
        right: 6px;
        bottom: 26px;
        cursor: pointer;
      }
      img {
        width: 90px;
        height: 90px;
        max-width: 100%;
        object-fit: cover;
      }
    }
  }
  @media (max-width: 690px) {
    .image-wrapper {
      width: 60px;
      height: 60px;
      img {
        width: 60px;
        height: 60px;
      }
    }
  }
`;
const GroupImageWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  /* white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis; */
  .group-name {
    /* white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%; */
    h3 {
      position: relative;
    }
    h4 {
      font-size: 16px;
      font-family: "latosemibold";
      margin: 2px 0;
    }
    h5 {
      font-size: 15px;
      font-family: "latosemibold";
    }
    /* .white-color {
    background-image: -webkit-gradient(linear,left top,right top,color-stop(0%,rgba(255,255,255,0)),color-stop(100%,rgba(255,255,255,1)));
    background-image: -webkit-linear-gradient(left,rgba(255,255,255,0),rgba(255,255,255,1));
    background: linear-gradient(to right,rgba(255,255,255,0),rgba(255,255,255,1));
    filter: progid:DXImageTransform.Microsoft.gradient(GradientType=1,StartColorStr='#00ffffff',EndColorStr='#ffffff');
    bottom: 0;
    height: 25px;
    max-height: 100%;
    pointer-events: none;
    position: absolute;
    right: 0;
    width: 60px;
  } */
  }
  .MuiAvatar-root {
    width: 90px;
    height: 90px;
    border: 1px solid #c9c9c9;
  }
  /* .image-wrapper {
    width: 90px;
    height: 90px;
    border-radius: 50%;
    overflow: hidden;
    border: 1px solid #c9c9c9;
    img {
      width: 90px;
      height: 90px;
      max-width: 100%;
      object-fit: cover;
    }
  } */
  @media (max-width: 576px) {
    .image-wrapper {
      img{
        width: 50px !important;
        height: 50px !important;
        position: relative;
        top: 15px;
        right: 18px;
      }
      svg{
        right : 34px !important;
      }
    }
    .margin-style-1{
      margin-left: -3px;
    }
    .margin-style-2{
      margin-left: -34px;
    }
  }
  @media (max-width: 690px) {
    .MuiAvatar-root {
      width: 60px;
      height: 60px;
    }
  }
`;
const AccordionConatiner = styled.div`
  padding-top: 33px;
  /* max-height: calc(100vh - 405px);
    overflow: auto; */
  .MuiAccordionSummary-content,
  .MuiAccordionSummary-content.Mui-expanded {
    margin: 0;
  }
  .MuiAccordionSummary-content {
    display: grid;
    padding-bottom: 24px;
  }
  .MuiAccordion-root {
    box-shadow: none;
    ::before {
      background-color: transparent;
    }
  }
  .MuiAccordion-root.Mui-expanded {
    border-bottom: solid 1px #c9c9c9;
  }
  .MuiAccordionSummary-root {
    border-radius: 9px;
    box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.16);
    background-color: #fff;
    margin: 0 20px 33px;
    padding-left: 0;
  }
  @media (max-width: 690px) {
    .MuiAccordionSummary-root {
      margin: 0 20px 20px;
    }
    .MuiAccordionSummary-content {
      padding-bottom: 20px;
    }
  }
`;
const AccordionDetailsContainer = styled.div`
  width: 100%;
  ${AccordionHeader} {
    padding: 24px 38px;
    border-radius: 9px;
    box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.16);
    background-color: #fff;
    max-width: calc(100% - 40px);
    margin: 0 auto 15px;
    grid-template-columns: 1fr auto;
  }
  ${GroupImageWrapper} {
    .MuiAvatar-root {
      width: 78px;
      height: 78px;
      border: 1px solid #c9c9c9;
    }
  }
  @media (max-width: 690px) {
    ${AccordionHeader} {
      max-width: calc(100% - 20px);
      padding: 20px 0 20px 20px;
    }
    ${GroupImageWrapper} {
      .MuiAvatar-root {
        width: 50px;
        height: 50px;
        border: 1px solid #c9c9c9;
      }
    }
  }
`;
const BoxActionBtn = styled.div`
  display: grid;
  grid-gap: 18px;
  button {
    height: 31px;
    text-transform: capitalize;
    padding: 0 15px;
    svg {
      margin-right: 9px;
    }
  }
  @media (max-width: 690px) {
    grid-auto-flow: column;
  }
`;

const Description = styled.div`
  padding-left: 150px;
  word-break: break-word;
  line-height: normal;
  font-size: 14px;
  @media (max-width: 690px) {
    padding-left: 20px;
    margin-top: 5px;
  }
`;

export {
  AccordionHeader,
  GroupImageWrapper,
  CreateGroupWrappe,
  AccordionConatiner,
  AccordionDetailsContainer,
  BoxActionBtn,
  Description,
};
